<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;">ABONELİK TİPLERİ</h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Ayarlar</li>
            <li class="breadcrumb-item active">Abonelik Tipleri</li>
        </ol>
    </div>
    <div class="data-grid">
        <p-table #dt [value]="contractTypes$ | async" [paginator]="true" [rows]="25" [showCurrentPageReport]="true"
            styleClass="p-datatable-sm" [rowHover]="true"
            currentPageReportTemplate="{totalRecords} veriden {first} - {last} gösteriliyor.."
            [globalFilterFields]="['contractTypeCode','contractTypeName','periodName']" [responsive]="true"
            [rowsPerPageOptions]="[5,10,25,50]">
            <ng-template pTemplate="caption">
                <button pButton type="button" class="p-button-info" label="Yeni"
                    routerLink="/contract-type-add"></button>
                <div style="text-align: right">
                    <input style="float:right" type="text" pInputText size="50" placeholder="Ara"
                        (input)="applyFilterGlobal($event, 'contains')" style="width:auto">
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="contractTypeCode" [width]="'30%'">Abonelik Tipi Kodu<p-sortIcon
                            field="contractTypeCode"></p-sortIcon>
                    </th>
                    <th pSortableColumn="contractTypeName" [width]="'30%'">Abonelik Tipi Adı<p-sortIcon
                            field="contractTypeName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="periodName" [width]="'30%'">Dönem<p-sortIcon field="periodName"></p-sortIcon>
                    </th>

                    <th [width]="'10%'">

                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-contractTypes>
                <tr>
                    <td>{{contractTypes.contractTypeCode}}</td>
                    <td>{{contractTypes.contractTypeName}}</td>
                    <td>{{contractTypes.periodName}}</td>
                    <td>
                        <button pButton pRipple type="button" icon="pi pi-pencil"
                            class="p-button-rounded p-button-success" pTooltip="Güncelle" tooltipPosition="bottom"
                            routerLink="/contract-type-update/{{contractTypes.id}}"></button>
                        <button pButton pRipple type="button" icon="pi pi-trash"
                            class="p-button-rounded p-button-danger" pTooltip="Sil" tooltipPosition="bottom"
                            (click)="showDeleteModal(contractTypes.id)"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<p-dialog header="ABONELİK TİPİ SİL" [(visible)]="deleteModal" [modal]="true" [style]="{width: '50vw'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p class="p-m-0">Abone tipi silinecek. Onaylıyor musunuz?</p>
    <ng-template pTemplate="footer">
        <p-button (click)="deleteModal=false" label="Vazgeç" styleClass="p-button-dark"></p-button>
        <p-button (click)="deleteContractType()" label="Sil" styleClass="p-button-danger"></p-button>
    </ng-template>
</p-dialog>